import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-dental-assistance',
  templateUrl: './dental-assistance.component.html',
  styleUrls: ['./dental-assistance.component.css', '../../assets/layout/style/layout.css' ]
})
export class DentalAssistanceComponent implements OnInit {

  appointment: boolean = false;
  firstDate: boolean = false;
  services: boolean = false;
  knowExperience: boolean = false;

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  showDialog () {
    this.appointment = true;
  }

  showDialog2 () {
    this.firstDate = true;
  }

  showDialog3 () {
    this.services = true;
  }

  showDialog4 () {
    this.knowExperience = true;
  }

  async navigate() {
    this.router.navigate(['home/dental-access']);
  }

}
